export const SET_THEME = 'GLOBAL_SET_THEME';
export const ADD_JOB = 'GLOBAL_ADD_JOB';
export const REMOVE_JOB = 'GLOBAL_REMOVE_JOB';